<template>
    <section class="shadow-xl p-4 gap-1.5 rounded-lg bg-white">
        <Handle type="target" :position="Position.Left" />

        <article class="flex items-center gap-2">
            <article class="bg-primary-950 rounded-md p-2 inline-block">
                <Icon icon="tabler:code" class="text-xl text-white"/>
            </article>
            <input type="text" placeholder="Script Name" v-model="data.name" 
                   class="block font-bold text-sm w-full outline-none border p-2 rounded-lg"/>
        </article>

        <div class="flex items-center justify-between mt-2">
            <div></div>
            <button class="text-blue-600 text-sm flex items-center gap-1" @click="() => isEditorOpen = true">
                Open Editor
                <Icon icon="majesticons:open-line" />
            </button>
        </div>
        <custom-code-editor 
                            v-model="data.script"
                            :options="{
                                readOnly: true,
                                fontSize: 7,
                                scrollBeyondLastLine: false,
                            }" 
                        />
        
        <custom-modal
                title="Editor"
                subTitle="Edit your code here" 
                :is-open="isEditorOpen"
                width="w-full"
                @cancel="() => isEditorOpen = false">
                <template v-slot:body>
                    <custom-code-editor v-model="data.script" class="h-full min-h-screen" />
                </template>
        </custom-modal>

        <Handle type="source" :position="Position.Right" />
    </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Icon } from "@iconify/vue"
import { Handle, Position, useNode } from "@vue-flow/core"
import CustomModal from '../../CustomModal.vue';
import CustomCodeEditor from '../../CustomCodeEditor.vue';

const node = useNode()

const isEditorOpen = ref(false)
const data = computed({
  get: () => { 
    return node.node.data;
  },
  set: (value) => {
    node.node.data = value
  }
})
</script>